module.exports = __webpack_public_path__ + "static/media/X_Logo.e3544678.svg";